import { clsx } from 'clsx';
import { forwardRef } from 'react';

const Select = forwardRef(({ label, error, hint, className, required, children, ...props }, ref) => (
  <div className="space-y-1">
    {label && (
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
    )}
    <select
      ref={ref}
      className={clsx(
        'block w-full rounded-lg border bg-white px-3 py-2 text-sm text-gray-900 transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500',
        error
          ? 'border-red-400 focus:ring-red-400 focus:border-red-400'
          : 'border-gray-300 hover:border-gray-400',
        'disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed',
        className
      )}
      {...props}
    >
      {children}
    </select>
    {error && <p className="text-xs text-red-600">{error}</p>}
    {hint && !error && <p className="text-xs text-gray-500">{hint}</p>}
  </div>
));
Select.displayName = 'Select';
export default Select;
